export const getProductUrl = (baseUrl, productId, productVariant, ctaRef) => {
  const productUrl = baseUrl + "/prd/" + productId;

  if (productVariant.length) {
    return productUrl + "?clr=" + productVariant;
  }

  return productUrl;
};
